import type { StrapiListResponse, Post, Category as FrontCategory } from '@/interfaces/strapi';
import type { PostModel, StrapiResponseModel } from '@/interfaces/model';
import { mapImage, mapStrapiFile, toAbsolute } from '@/helpers/strapi-assets-helpers';

const mapCategoryLite = (c: PostModel['web_categorias_noticia']): FrontCategory => ({
	id: c.documentId,
	name: c.name,
	description: c.description,
	slug: c.slug,
	image: c.image ? mapImage(c.image, 'full') : { url: '', alt: c.name },
});

const mapPostImage = (file: PostModel['image']): { url: string; alt: string } => {
	if (!file) return { url: '', alt: '' };
	return {
		url: toAbsolute(file.url),
		alt: file.alternativeText ?? file.caption ?? file.name ?? '',
	};
};

export const postMapper = (p: PostModel): Post => ({
	id: p.id,
	name: p.name,
	slug: p.slug,
	file: mapStrapiFile(p.file),
	image: mapPostImage(p.image),
	content: p.content,
	category: mapCategoryLite(p.web_categorias_noticia),
	createdAt: p.createdAt,
	publishedAt: p.publishedAt,
});

export const postListMapper = (res: StrapiResponseModel<PostModel>): StrapiListResponse<Post> => {
	const list = (res.data ?? []).map(postMapper);
	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};
	return { list, pagination };
};
